class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.summaryToggle) {
      this.summaryToggle.style.pointerEvents = 'none';
    }

    if (document.readyState === 'complete') {
      this.initListeners();
    } else {
      window.addEventListener('load', this.initListeners.bind(this));
    }
  }

  initListeners() {
    if (this._listenersInitialized) return;
    this._listenersInitialized = true;

    if (this.summaryToggle) {
      this.summaryToggle.style.pointerEvents = '';
    }

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    // Add touch events for mobile
    this.summaryToggle.addEventListener('touchstart', this.onSummaryTouch.bind(this), { passive: true });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryTouch(event) {
    // Prevent default only if we're going to handle the touch
    if (!this.detailsContainer.hasAttribute('open')) {
      setTimeout(() => {
        this.open(event);
      }, 0);
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Add touch event listener for body when modal is open
    document.body.addEventListener('touchstart', this.onBodyClickEvent, { passive: true });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.removeEventListener('touchstart', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
